import { render, staticRenderFns } from "./contentTagRecycle.vue?vue&type=template&id=4e823b34&"
import script from "./contentTagRecycle.vue?vue&type=script&lang=js&"
export * from "./contentTagRecycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports